<template>

  <div class="user">
    <!--添加任务-->
    
    
    <!-- <div style="float: left;width:25%;">
        <Supply_s  @handleCurrentChange="handleCurrentChangeS" @reast="reasts"></Supply_s>
    </div> -->
      
      <!-- <div style="float: left;width:72%;margin-left: 1%;"> -->

    
    
    
    <div class="common-seach-wrap">
      <el-form :inline="true" size="small" :model="formInline" class="demo-form-inline">
        <el-form-item label="仓库名称">
          <el-input placeholder="请输入仓库名称" v-model="formInline.search">
        
          </el-input>
        </el-form-item>
        <el-form-item >
          <el-button type="primary" icon="el-icon-search" @click="getData">查询</el-button>
        </el-form-item>

      </el-form>
    </div>

    <div class="common-level-rail">
      <el-button size="small" icon="el-icon-plus" type="primary" 
      v-auth="'/plus/warehouse/index/add'"
      @click="addClick">添加仓库</el-button>
    </div>

    <div class="product-content">
      <el-form ref="form" :model="form" label-width="100px">
        <div class="table-wrap">
          <el-table size="small" :data="tableData" border style="width: 100%" v-loading="loading">
            <el-table-column prop="warehouse_id" label="ID"></el-table-column>
            <el-table-column prop="supply.name" label="供应商/供应商"></el-table-column>
            <el-table-column prop="numb" label="编号"></el-table-column>
            <el-table-column prop="name" label="名称"></el-table-column>
            <el-table-column prop="label" label="标签"></el-table-column>
            <el-table-column prop="sort" label="排序"></el-table-column>

            <el-table-column fixed="right" label="操作" width="140">
              <template slot-scope="scope">
                <el-button @click="kwClick(scope.row)" type="text" size="small">库位</el-button>
                <el-button @click="editClick(scope.row)" 
                   v-auth="'/plus/warehouse/index/edit'"
                type="text" size="small">编辑</el-button>
                <el-button @click="deleteClick(scope.row)"
                   v-auth="'/plus/warehouse/index/del'"
                type="text" size="small">删除</el-button>
              </template>
            </el-table-column>
          </el-table>
        </div>
      </el-form>
      <!--分页-->
      <div class="pagination">
        <el-pagination
          @size-change="handleSizeChange"
          @current-change="handleCurrentChange"
          background
          :current-page="curPage"
          :page-size="pageSize"
          layout="total, prev, pager, next, jumper"
          :total="totalDataNumber"
        ></el-pagination>
      </div>
    <!-- </div> -->

    </div>
    
    <Add :open_add="open_add" v-if="open_add"   @close="closeAdd"></Add>
    <Edit :open_add="open_edit" :warehouse_id="warehouse_id"  v-if="open_edit"   @close="closeEdit"></Edit>

    <el-dialog  style="text-align: center" title="设置标题" :visible.sync="dialogVisible" @close='dialogFormVisible' 
    :close-on-click-modal="false" 
               :close-on-press-escape="false" :append-to-body="true">
    </el-dialog>


    <Kw :open_kw="open_kw" :warehouse_id="warehouse_id"  v-if="open_kw"   @close="closeKw"></Kw>
  
  </div>
</template>

<script>
  import WarehouseApi from '@/api/warehouse.js';
  import Add from './part/add.vue';
  import Edit from './part/edit.vue';
  import Kw from './kw/index.vue';
  import Supply_s from '@/components/select/platform';
  export default {
    components: {
      Add,
      Edit,
      Kw,
      Supply_s
    },
    inject: ['reload'],
    data() {
      return {
        /*是否加载完成*/
        loading: true,
        /*列表数据*/
        tableData: [],
        /*一页多少条*/
        pageSize: 20,
        /*一共多少条数据*/
        totalDataNumber: 0,
        /*当前是第几页*/
        curPage: 1,
        /*搜索表单对象*/
        form: {},
        formInline: {
          search:"",
          id:'',
        },

        open_add:false,
        open_edit:false,
        warehouse_id:"",
        dialogVisible:false,
        open_kw:false,
      };
    },
    created() {

      /*获取列表*/
      this.getTableList();
    },
    methods: {
      handleCurrentChangeS(val){
        this.formInline.id = val.id
        this.getData();
      },
      reasts(){
  
        this.formInline.id = ''
        this.getData();
      },
      kwClick(row){
        this.warehouse_id = row.warehouse_id;
        this.open_kw = true;
      },
      dialogFormVisible(){
        this.dialogVisible = false;
      },
      setting(e){//仓库标题设置
        // this.categorya_id = e
        this.dialogVisible = true;
      },
       /*关闭添加*/
    closeAdd(e){
      this.open_add=false;
      this.getTableList();
    },
    closeEdit(e){
      this.open_edit=false;
      this.getTableList();
    },
    closeKw(e){
      this.open_kw=false;
      this.getTableList();
    },
    getData(){
      this.getTableList();
    },
      /*选择第几页*/
      handleCurrentChange(val) {
        this.curPage = val;
        this.getTableList();
      },

      /*每页多少条*/
      handleSizeChange(val) {
        this.curPage = 1;
        this.pageSize = val;
        this.getTableList();
      },

      /*获取列表*/
      getTableList() {
        let self = this;
        let Params = this.formInline;
        Params.page = self.curPage;
        Params.list_rows = self.pageSize;
        self.loading = true;
        WarehouseApi.list(Params, true)
          .then(data => {
            self.loading = false;
            self.tableData = data.data.list.data;
            self.totalDataNumber = data.data.list.total;
          })
          .catch(error => {
          });
      },

      /*搜索查询*/
      onSubmit() {
        this.curPage = 1;
        this.getTableList();
      },

      /*添加任务*/
      addClick() {
        this.open_add = true
      },

      /*编辑活动*/
      editClick(row) {
        this.warehouse_id = row.warehouse_id;
        this.open_edit = true
      },

      /*删除*/
      deleteClick(row) {
        let self = this;
        self
          .$confirm('此操作将永久删除该记录, 是否继续?', '提示', {
            confirmButtonText: '确定',
            cancelButtonText: '取消',
            type: 'warning'
          })
          .then(() => {
            WarehouseApi.del(
              {
                warehouse_id: row.warehouse_id
              },
              true
            )
              .then(data => {
                if (data.code == 1) {
                  self.$message({
                    message: '删除成功',
                    type: 'success'
                  });
                  this.getTableList();
                } else {
                  self.$message.error('错了哦，这是一条错误消息');
                }
              })
              .catch(error => {
              });
          })
          .catch(() => {
          });
      }
    }
  };
</script>

<style></style>



// WEBPACK FOOTER //
// src/views/plus/warehouse/index/index.vue